import Plyr from 'plyr';
import Swiper, {Swiper as SwiperType} from 'swiper';
import {A11y, EffectFade, FreeMode, Navigation, Pagination, Thumbs} from 'swiper/modules';
import {defineComponent} from "@/js/utils/alpine";

interface Video {
    slideIndex: number;
    video: Plyr;
}

export default defineComponent(() => ({
    swiperInstance: undefined as SwiperType | undefined,
    init() {
        const swiperEl = this.$refs.swiper;

        let videos: Video[] = [];
        const videoSlideEl = swiperEl.querySelectorAll('[data-plyr-video-slide]') as NodeListOf<HTMLElement>;

        if (videoSlideEl.length > 0) {
            videoSlideEl.forEach(el => {
                const plyrVideo = new Plyr(el, {
                    ratio: '16:9',
                })

                videos.push({
                    slideIndex: parseInt(el.dataset.plyrVideoSlide as string),
                    video: plyrVideo
                })
            });
        }

        this.swiperInstance = new Swiper(swiperEl, {
            modules: [A11y, Navigation, Pagination, FreeMode, Thumbs, EffectFade],
            slidesPerView: 1,
            effect: 'fade',
            loop: false,
            fadeEffect: {
                crossFade: true
            },
        });


        this.swiperInstance.on('slideChange', () => {
            // Filter video object of previous slide
            const res = videos.filter(el => el.slideIndex == this.swiperInstance!.previousIndex);

            // If previous slide is a VIDEO
            if (res.length > 0) {
                const videoPlyr = res[0].video;
                // If previous video is playing.
                if (videoPlyr.playing) {
                    // Stop it!
                    videoPlyr.stop();
                }
            }

        });
    }
}))

